"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GenericRowsOfDetails = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var GenericRowsOfDetails = function GenericRowsOfDetails(_ref) {
  var titles = _ref.titles,
    contents = _ref.contents,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? 1 : _ref$columns;
  function rowOfData(array, colWidth, idx) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, {
      columns: 16,
      className: "no-padding"
    }, array.map(function (element, idx2) {
      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
        key: "gridCol1-".concat(idx, "-").concat(idx2),
        width: colWidth
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Header, {
        className: "generic-card-row  --header",
        as: "h6"
      }, element.title));
    })), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, {
      className: "generic-card-row --text"
    }, array.map(function (element, idx3) {
      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
        key: "gridCol2-".concat(idx, "-").concat(idx3),
        width: colWidth
      }, element.text);
    })));
  }
  if (titles.length !== contents.length) return null;
  var colWidth = Math.floor(16 / columns);
  var combinedArray = titles.map(function (title, idx) {
    return {
      title: title,
      text: contents[idx]
    };
  });
  return _lodash.default.chunk(combinedArray, columns).map(function (chunk, idx) {
    return rowOfData(chunk, colWidth, idx);
  });
};
exports.GenericRowsOfDetails = GenericRowsOfDetails;
var _default = GenericRowsOfDetails;
exports.default = _default;